import { render, staticRenderFns } from "./synopsis.vue?vue&type=template&id=bda61704&scoped=true"
import script from "./synopsis.vue?vue&type=script&lang=js"
export * from "./synopsis.vue?vue&type=script&lang=js"
import style0 from "./synopsis.vue?vue&type=style&index=0&id=bda61704&prod&lang=css"
import style1 from "./synopsis.vue?vue&type=style&index=1&id=bda61704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda61704",
  null
  
)

export default component.exports